





















































































import * as _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { ITemplateCreate } from '@/interfaces';
import {
  dispatchCreateTemplate,
  dispatchGetServices,
  dispatchParseMessage,
  dispatchGetSenders,
  dispatchGetPriorities,
  readServices,
  readSenders,
  readPriorities,
  dispatchGetMNOs,
  readMNOs,
  dispatchSuggestTags,
} from '@/store/admin/accessors';
import VTextAreaWithValidation from '@/components/VTextAreaWithValidation.vue';
import VTextFieldWithValidation from '@/components/VTextFieldWithValidation.vue';
import VSelectWithValidation from '@/components/VSelectWithValidation.vue';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    VTextFieldWithValidation,
    VSelectWithValidation,
    VTextAreaWithValidation,
  },
})
export default class CreateTemplate extends Vue {
  public valid = false;
  public templateValue: string = '';
  public serviceName: string = '';
  public senderName: string = '';
  public priority: string = 'MEDIUM';
  public mnoBans: string[] = [];
  public tags: string[] = [];
  public servicesList: string[] = [];
  public sendersList: string[] = [];
  public prioritiesList: string[] = [];
  public mnosList: string[] = [];
  public active = true;
  public commentary: string = '';
  public ignoreUserBans: boolean = false;
  public messageToParse: string = '';
  public messageParseResult: boolean | null = null;
  public priorities;
  public services;
  public senders;
  public $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  public tagsSearch: string = '';
  public tagsSelect: string[] = [];
  public tagsFetchDebounce: Function | null = null;

  public async mounted() {
    await dispatchGetServices(this.$store);
    await dispatchGetSenders(this.$store);
    await dispatchGetPriorities(this.$store);
    await dispatchGetMNOs(this.$store);
    this.services = new Map<string, number>(
      readServices(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    this.senders = new Map<string, number>(
      readSenders(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    this.priorities = new Map<string, number>(
      readPriorities(this.$store).map((item) => [item.name, item.id] as [string, number]),
    );
    for (const item of readMNOs(this.$store)) {
      this.mnosList.push(item.name);
    }
    this.servicesList = Array.from(this.services.keys());
    this.sendersList = Array.from(this.senders.keys());
    this.prioritiesList = Array.from(this.priorities.keys());
    this.reset();
  }

  @Watch('messageToParse')
  public updateMessageParseResult() {
    if (this.messageParseResult !== null) {
      this.messageParseResult = null;
    }
  }

  public reset() {
    this.templateValue = '';
    this.serviceName = '';
    this.senderName = '';
    this.priority = 'MEDIUM';
    this.mnoBans = [];
    this.tags = [];
    this.commentary = '';
    this.ignoreUserBans = false;
    this.$refs.observer.reset();
  }

  public cancel() {
    this.$router.back();
  }

  public async parseMessage() {
    const result = await dispatchParseMessage(this.$store, {
      template: this.templateValue,
      message: this.messageToParse,
    });
    if (result) {
      this.messageParseResult = result.correct;
    } else {
      this.messageParseResult = null;
    }
  }

  public async submit() {
    if (await this.$refs.observer.validate()) {
      const createdTemplate: ITemplateCreate = {
        template: this.templateValue,
        service_id: this.services.get(this.serviceName),
        sender_id: this.senders.get(this.senderName),
        priority_id: this.priorities.get(this.priority),
        mno_bans: this.mnoBans,
        tags: this.tags,
        active: this.active,
        commentary: this.commentary,
        ignore_user_bans: this.ignoreUserBans,
      };
      const result = await dispatchCreateTemplate(this.$store, createdTemplate);
      if (result) {
        this.$router.push('/main/admin/templates');
      }
    }
  }

  @Watch('tagsSearch')
  async tagsSearchChanged() {
    this.tagsFetchDebounce =
      this.tagsFetchDebounce ||
      _.debounce(() => {
        dispatchSuggestTags(this.$store, this.tagsSearch).then(
          (data) => (this.tagsSelect = data ? data.map((item) => item.text) : []),
        );
      }, 250);
    this.tagsFetchDebounce();
  }
}
